import { ArrayUtil } from "@mcleod/core";
import { Component } from "..";
import { DesignableObject } from "../base/DesignableObject";
import { DomEvent } from "./DomEvent";
import { Event } from "./Event";
import { Textbox } from "../components/textbox/Textbox";

export interface ContainerContentsChangedListener extends EventListener {
    (event: ContainerContentsChangedEvent): void;
}

/**
 * Event that fires when a Component (or Components) is (are) added to or removed from a Container.  The event will not
 * fire during a reLayout().
 */
export class ContainerContentsChangedEvent extends Event {
    private _childrenAdded: Component[] = [];
    private _childrenRemoved: Component[] = [];

    constructor(component: DesignableObject, childrenAdded: Component | Component[],
        childrenRemoved: Component | Component[], domEvent?: Event | DomEvent) {
        super(component, domEvent);
        ArrayUtil.addAllNoDuplicates(this._childrenAdded, childrenAdded);
        ArrayUtil.addAllNoDuplicates(this._childrenRemoved, childrenRemoved);
    }

    public override get target(): Textbox {
        return super.target as Textbox;
    }

    public get childAdded(): Component {
        return ArrayUtil.getFirstElement(this._childrenAdded);
    }

    public get childrenAdded(): Component[] {
        return this._childrenAdded;
    }

    public get childRemoved(): Component {
        return ArrayUtil.getFirstElement(this._childrenRemoved);
    }

    public get childrenRemoved(): Component[] {
        return this._childrenRemoved;
    }

    public addSelection(item: Component) {
        this._childrenAdded.push(item);
    }

    public addDeselection(item: Component) {
        this._childrenRemoved.push(item);
    }

    public hasChildrenAdded(): boolean {
        return ArrayUtil.isEmptyArray(this._childrenAdded) === false;
    }

    public hasChildrenRemoved(): boolean {
        return ArrayUtil.isEmptyArray(this._childrenRemoved) === false;
    }

    override validate(): boolean {
        return this.hasChildrenAdded() || this.hasChildrenRemoved();
    }

    get userInitiatedChange(): boolean {
        return this.domEvent != null;
    }
}
